// Phase 83t — Legacy redirect for old /athlete/matches/:matchId/live URLs.
// Looks up the match's tournament_id from the backend and forwards user to
// /athlete/tournaments/{tournament_id}/livestream?match={matchId}.
// v16.17 Phase C.31 — Path-based tab (SEO-friendly VN slug).
// If lookup fails, fall back to the matches list.
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { tabCodeToSlug } from "../lib/tournamentTabs";

export default function LegacyLiveMatchRedirect() {
  const { matchId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    async function go() {
      try {
        // Try public match details first (no auth required)
        const r = await api.get(`/public/matches/${matchId}`);
        const tid = r.data?.tournament_id || r.data?.tournamentId;
        // Prefer tournament slug (SEO), fallback UUID.
        const tSlug = r.data?.tournament_slug || r.data?.tournamentSlug || tid;
        const mCode = r.data?.match_code || r.data?.matchCode;
        const mParam = mCode ? String(mCode).toLowerCase() : matchId;
        if (!cancelled && tSlug) {
          navigate(
            `/athlete/tournaments/${tSlug}/${tabCodeToSlug("livestream")}?match=${mParam}`,
            { replace: true },
          );
          return;
        }
      } catch {
        /* fall through */
      }
      if (!cancelled) navigate("/athlete/matches", { replace: true });
    }
    if (matchId) go();
    return () => { cancelled = true; };
  }, [matchId, navigate]);

  return (
    <div
      className="min-h-screen bg-[#060B14] text-white flex items-center justify-center"
      data-testid="legacy-live-redirect"
    >
      <span className="text-sm text-white/55">Đang chuyển hướng…</span>
    </div>
  );
}
